class TokenManager {
  estimateTokens(text) {
    if (typeof text !== 'string' || !text) {
      return 0;
    }

    const characterEstimate = Math.ceil(text.length / 3.5);
    const wordEstimate = Math.ceil(
      text.split(/\s+/).filter(Boolean).length * 1.35
    );

    return Math.max(characterEstimate, wordEstimate);
  }

  checkTokenLimit(text, model = 'gpt-4.1') {
    const tokenCount = this.estimateTokens(text);
    const inputLimit = 1047576;
    const reservedTokens = 12000;
    const usableLimit = inputLimit - reservedTokens;

    return {
      tokenCount,
      limit: usableLimit,
      modelUsed: model,
      isWithinLimit: tokenCount <= usableLimit,
      percentage: (tokenCount / usableLimit) * 100
    };
  }

  splitTextIntoChunks(text) {
    const maximumChunkTokens = 90000;
    const paragraphs = text.split(/\n{2,}/).filter(Boolean);
    const chunks = [];
    let current = '';

    paragraphs.forEach((paragraph) => {
      const candidate = current ? `${current}\n\n${paragraph}` : paragraph;

      if (this.estimateTokens(candidate) > maximumChunkTokens && current) {
        chunks.push(current);
        current = paragraph;
      } else {
        current = candidate;
      }
    });

    if (current) {
      chunks.push(current);
    }

    return chunks;
  }

  formatTokenInfo(tokenCount, limit) {
    const percentage = Math.round((tokenCount / limit) * 100);
    let color = 'text-green-400';

    if (percentage > 90) {
      color = 'text-red-400';
    } else if (percentage > 70) {
      color = 'text-yellow-400';
    }

    return {
      color,
      percentage,
      formatted: `${tokenCount.toLocaleString()} / ${limit.toLocaleString()} estimated tokens`
    };
  }
}

export default new TokenManager();